import React, { useEffect, useState } from 'react'
import {
    Breadcrumbs,
    Button,
    Card,
    CardContent,
    Grid,
    LinearProgress,
    Link as MLink,
    Snackbar,
    TextField,
    Typography
} from '@material-ui/core'
import { Link } from 'react-router-dom'
import { apiGet, apiPost } from '../../functionsAPI'
import ltrim from 'validator/lib/ltrim'
import rtrim from 'validator/lib/rtrim'
import MuiAlert from '@material-ui/lab/Alert'
import { Autocomplete } from '@material-ui/lab'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

const AddPlant = (props) => {
    const [name, setName] = useState(null)
    const [cities,setCities] = useState([])
    const [city,setCity] = useState(null)
    const [contact,setContact] = useState(null)
    const [address,setAddress] = useState(null)
    const [showAlert, setShowAlert] = useState(false)
    const [alertType, setAlertType] = useState('success')
    const [alertMessage, setAlertMessage] = useState('')
    const [loading, setLoading] = useState(false)

    const nameChange = (e) => {
        var value = e.target.value
        setName(value)
    }

    const addressChange = (e) => {
        let value = e.target.value
        setAddress(value)
    }

    const contactChange = (e) => {
        let value = e.target.value
        setContact(value)
    }

    const trim = (value) => {
        value = ltrim(value)
        value = rtrim(value)
        return value
    }

    const onSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        const data = {
            name: name ? trim(name) : null,
            address: address ? trim(address) : null,
            contact: contact ? trim(contact) : null,
            city_id: city ? city.id : null
        }
        const url = '/plants'
        apiPost(url, data).then(response => {
            setLoading(false)
            props.history.push('/dashboard/plants')
        }).catch(error => {
            console.log(error)
            setAlertType('error')
            setAlertMessage(error)
            setShowAlert(true)
            setLoading(false)
        })
    }

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowAlert(false);
    }

    const progress = loading ? (<LinearProgress />) : ('')

    useEffect(()=>{
        getCities()
        // eslint-disable-next-line
    },[])

    const getCities = () => {
        const url = '/cities'
        apiGet(url)
        .then(response => {
            setCities(response.data.list)
        }).catch(error => {
            console.log(error)
            setAlertType('error')
            setAlertMessage(error)
            setShowAlert(true)
        })
    }

    return (
        <div>
            <Breadcrumbs aria-label="breadcrumb">
                <MLink color="inherit" href="/#/dashboard">
                    Dashboard
                </MLink>
                <MLink color="inherit" href="/#/dashboard/plants">
                    Plants
                </MLink>
                <Typography color="textPrimary">Add Plant</Typography>
            </Breadcrumbs>
            <br />
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={showAlert}
                autoHideDuration={5000}
                onClose={handleAlertClose}
            >
                <Alert onClose={handleAlertClose} severity={alertType}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            {progress}
            <Card>
                <CardContent>
                    <form onSubmit={onSubmit} className="mt-5">
                        <Grid
                            container
                            spacing={3}
                            direction="column"
                        >
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Name"
                                    value={name}
                                    variant="outlined"
                                    inputProps={{ minLength: 2, maxLength: 36 }}
                                    onChange={nameChange}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    multiline
                                    fullWidth
                                    value={address}
                                    label="Address"
                                    name="category"
                                    variant="outlined"
                                    onChange={addressChange}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    value={contact}
                                    label="Contact"
                                    name="category"
                                    variant="outlined"
                                    inputProps={{ minLength: 10, maxLength: 17 }}
                                    onChange={contactChange}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    options={cities}
                                    value={city}
                                    autoHighlight
                                    getOptionLabel={(option) => option.name }
                                    renderInput={(params) => <TextField
                                        {...params}
                                        label="City"
                                        variant="outlined"
                                    />}
                                    onChange={(event, value) => setCity(value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Link to="/dashboard/plants">
                                    <Button
                                        type="submit"
                                        variant="contained"
                                    >
                                        Back
                                    </Button>
                                </Link>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={loading}
                                >
                                    Add
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}

export default AddPlant
